export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';
export const MODAL_HIDE_ALL = 'MODAL_HIDE_ALL';

export const modalShow = (component, {fullScreen, onClose} = {}) => async dispatch => {
  dispatch({ type: MODAL_SHOW, payload: { component, fullScreen, onClose} });
};

export const modalHide = () => async dispatch => {
  dispatch({ type: MODAL_HIDE });
};

export const modalHideAll = () => async dispatch => {
  dispatch({ type: MODAL_HIDE_ALL });
};


// WEBPACK FOOTER //
// ./src/actions/modal.js